import { useCallback } from 'react';
import { useSession } from '@/contexts/session-context';

const API_URL = import.meta.env.VITE_API_URL ?? '';

export function useAdminFetch() {
  const { signIn } = useSession();

  return useCallback(
    async (path: string, options?: RequestInit) => {
      // Use the Headers class so content-type is merged case-insensitively —
      // prevents duplicate `Content-Type` if the caller also passes one
      // (which fetch would otherwise comma-join, breaking NestJS's body-parser).
      const headers = new Headers(options?.headers);
      headers.set('Content-Type', 'application/json');

      const res = await fetch(`${API_URL}${path}`, {
        ...options,
        credentials: 'include',
        headers,
      });
      if (res.status === 401) signIn();
      return res;
    },
    [signIn],
  );
}
